import { FormattedMessage, useIntl } from 'react-intl';
import { FormElement } from '../FormElement';
import { FormSection } from '../FormSection';
import { AdministratorAccess } from './AdministratorAccess';
import { ExtendedUserDTO } from '@/hooks/useGetAllAdmins';
import { formatDateTime } from '@/helpers/formatting';

interface Props {
  administrator: ExtendedUserDTO;
}

export const AdministratorProfileForm = ({ administrator }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <FormSection title={<FormattedMessage defaultMessage="Profil" />}>
        <FormElement
          label={<FormattedMessage defaultMessage="Förnamn" />}
          input={
            <p>
              {administrator.firstname || (
                <i className="text-text-700">
                  {formatMessage({ defaultMessage: 'Inget värde' })}
                </i>
              )}
            </p>
          }
        />
        <FormElement
          label={<FormattedMessage defaultMessage="Efternamn" />}
          input={
            <p>
              {administrator.lastname || (
                <i className="text-text-700">
                  {formatMessage({ defaultMessage: 'Inget värde' })}
                </i>
              )}
            </p>
          }
        />
        <FormElement
          label={<FormattedMessage defaultMessage="E-post" />}
          input={<p>{administrator.email}</p>}
        />
        <i className="text-text-800">
          <FormattedMessage defaultMessage="Profilinformationen ändras av användaren själv" />
        </i>

        <div className="flex flex-wrap gap-x-10 text-sm text-text-700">
          <p>
            <FormattedMessage
              defaultMessage="Skapad {date}"
              values={{
                date: formatDateTime(administrator.created_at),
              }}
            />
          </p>
          <p>
            <FormattedMessage
              defaultMessage="Uppdaterad {date}"
              values={{
                date: formatDateTime(administrator.updated_at),
              }}
            />
          </p>
        </div>
      </FormSection>

      <AdministratorAccess administrator={administrator} />
    </>
  );
};
